import React from 'react';
import NewLayout from '../NewTheam/Componte/Layout';
import HomeScreen from '../NewTheam/Pages/HomeScreen';

const newTheamRoutes = [
    { path: "/new-theam", element: <NewLayout><h1>New Theme</h1></NewLayout> },
];

export default newTheamRoutes;
